import { useCallback, useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../services/api"
import type { DiMaDetailsHeaderProps } from "../../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../../components/DiMaProgress"
import { DetailsHeaderTab } from "../../../../components/Helpers"
import { UserContext } from "../../../../context/UserContext"
import { ApplicationRoleUserGet } from "../../../../models/ApplicationRoleUser"
import { UserApplicationRoleDetails } from "./details_tab/UserApplicationRoleDetails"
import { useHashTab } from "../../../../../hooks/useHashTab"
import { UserApplicationRoleProperties } from "./properties_tab/UserApplicationRoleProperties"

export function UserApplicationRoleContainer() {
  const { userId, applicationId, roleId } = useParams()
  const { user, isLoadingUser } = useContext(UserContext)

  const { activeTab, handleTabChange } = useHashTab("details")
  const [userApplicationRole, setUserApplicationRole] = useState<ApplicationRoleUserGet>()
  const [reloadEntity, setReloadEntity] = useState<boolean>(true)
  const navigate = useNavigate()
  const returnURL = `/users/${userId}#apps-roles`

  useEffect(() => {
    if (userId && applicationId && roleId && reloadEntity === true) {
      digitalManagerApi
        .get<ApplicationRoleUserGet>(
          `/users/${userId}/applications/${applicationId}/roles/${roleId}`
        )
        .then((res) => {
          setUserApplicationRole(res.data)
          setReloadEntity(false)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [navigate, userId, applicationId, roleId, returnURL, reloadEntity])

  const reloadUserApplicationRole = useCallback(() => setReloadEntity(true), [])

  if (!userId || !applicationId || !roleId) {
    return <Navigate to={returnURL} />
  }

  if (!userApplicationRole || !user || isLoadingUser) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: userApplicationRole.role.name,
    label: "Role ID",
    subtitle: userApplicationRole.role.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DetailsHeaderTab
        detailsHeaderProps={detailsHeaderProps}
        tabItems={[
          { id: "details", label: "Details" },
          { id: "properties", label: "Properties" },
        ]}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {activeTab === "details" && (
        <UserApplicationRoleDetails
          userApplicationRole={userApplicationRole}
          setUserApplicationRole={setUserApplicationRole}
        />
      )}

      {activeTab === "properties" && (
        <UserApplicationRoleProperties
          userApplicationRole={userApplicationRole}
          reloadUserApplicationRole={reloadUserApplicationRole}
          user={user}
        />
      )}
    </div>
  )
}
